"use strict";
// Copyright (c) StrangeBee 2024
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("../errors");
const services_1 = require("../services");
const utils_1 = require("../utils");
class ParentController {
    constructor(bodyBuilder, sender) {
        this.endpoints = {
            create: '',
            edit: '',
            delete: '',
            get: '',
            bulkEdit: '',
            bulkDelete: '',
        };
        this.manager = new services_1.Manager(bodyBuilder, sender);
    }
    custom(queryParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const { selector: { name }, count, apiVersion = 'v1', } = queryParams;
            return this.manager.post({
                url: (queryParams === null || queryParams === void 0 ? void 0 : queryParams.customUrl) || '/:apiVersion/query?name=:name',
                params: {
                    apiVersion,
                    name: count ? `count-${name}` : name,
                },
            }, this.manager.prepareData(queryParams));
        });
    }
    list(queryParams) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.custom(queryParams);
        });
    }
    one(queryParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.custom(queryParams);
            if (Array.isArray(data) && data.length === 0) {
                (0, utils_1.errorManager)(null, errors_1.GenericError, {
                    prefix: `Element doesn't exist`,
                    errors: [{ statusCode: 404 }],
                });
            }
            return Array.isArray(data) ? data[0] : data;
        });
    }
    count(queryParams) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.custom(Object.assign(Object.assign({}, queryParams), { count: true }));
        });
    }
    getFullResponse(objectId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.endpoints.get) {
                throw new Error('Get Endpoint undefined !');
            }
            try {
                return this.manager.getFullResponse({ url: this.endpoints.get, params: { objectId } });
            }
            catch (e) {
                (0, utils_1.errorManager)(e, errors_1.GenericError, {
                    prefix: 'Cannot get element',
                    errors: [{ statusCode: 404 }],
                });
            }
        });
    }
    get(objectId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.endpoints.get) {
                throw new Error('Get Endpoint undefined !');
            }
            try {
                return this.manager.get({ url: this.endpoints.get, params: { objectId } });
            }
            catch (e) {
                (0, utils_1.errorManager)(e, errors_1.GenericError, {
                    prefix: 'Cannot get element',
                    errors: [{ statusCode: 404 }],
                });
            }
        });
    }
    create(data, objectId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.endpoints.create) {
                throw new Error('Create Endpoint undefined !');
            }
            try {
                return this.manager.post({ url: this.endpoints.create, params: typeof objectId === 'string' ? { objectId } : objectId }, data);
            }
            catch (e) {
                (0, utils_1.errorManager)(e, errors_1.GenericError, {
                    prefix: 'Cannot create element',
                    errors: [{ statusCode: 404 }],
                });
            }
        });
    }
    edit(data, objectId) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, utils_1.isRequired)(objectId);
            if (!this.endpoints.edit) {
                throw new Error('Edit Endpoint undefined !');
            }
            try {
                return this.manager.patch({ url: this.endpoints.edit, params: { objectId } }, data);
            }
            catch (e) {
                (0, utils_1.errorManager)(e, errors_1.GenericError, {
                    prefix: 'Cannot edit element',
                    errors: [{ statusCode: 404 }],
                });
            }
        });
    }
    multipleEdit(data, objectIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.all(objectIds.map((objectId) => this.edit(data, objectId)));
        });
    }
    delete(objectId, parentId) {
        (0, utils_1.isRequired)(objectId);
        if (!this.endpoints.delete) {
            throw new Error('Delete Endpoint undefined !');
        }
        try {
            return this.manager.delete({ url: this.endpoints.delete, params: { objectId, parentId } });
        }
        catch (e) {
            (0, utils_1.errorManager)(e, errors_1.GenericError, {
                prefix: 'Cannot delete element',
                errors: [{ statusCode: 404 }],
            });
        }
    }
    multipleDelete(objectIds, parentId) {
        return Promise.all(objectIds.map((objectId) => this.delete.bind(this, objectId, parentId)()));
    }
    bulkEdit(data, objectIds) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, utils_1.isRequired)(objectIds);
            if (!this.endpoints.bulkEdit) {
                throw new Error('Bulk Edit Endpoint undefined !');
            }
            try {
                return this.manager.patch({ url: this.endpoints.bulkEdit }, Object.assign({ ids: objectIds }, data));
            }
            catch (e) {
                (0, utils_1.errorManager)(e, errors_1.GenericError, {
                    prefix: 'Cannot bulk edit element',
                    errors: [{ statusCode: 404 }],
                });
            }
        });
    }
    bulkDelete(objectIds) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, utils_1.isRequired)(objectIds);
            if (!this.endpoints.bulkDelete) {
                throw new Error('Bulk Delete Endpoint undefined !');
            }
            try {
                return this.manager.delete({ url: this.endpoints.bulkDelete }, { ids: objectIds });
            }
            catch (e) {
                (0, utils_1.errorManager)(e, errors_1.GenericError, {
                    prefix: 'Cannot bulk delete element',
                    errors: [{ statusCode: 404 }],
                });
            }
        });
    }
}
exports.default = ParentController;
